export default __webpack_public_path__ + "static/media/artwork-1.038fa08e.png";